<template>
	<div>
		<div class="form-group row">
		    <label :class="{'col-lg-2 offset-lg-0 col-md-10 offset-md-1 col-12 col-form-label text-lg-right': true, 'text-muted': enableTextMuted, 'text-danger': (errors.assignee_id || errors['action.assignee_id'])}">
		    	Assigned To: <i v-if="!value.assignee_id" class="fa fa-asterisk small text-danger"></i>
		    </label>
		    <div class="col-lg-8 offset-lg-0 col-md-10 offset-md-1 col-12">
			    <div class="input-group">
			        <user-select ref="primaryAssigneeSelect" :selectedValues="userSelectValue" @vuselected="onUserSelectUpdate" style="width: 100%" :hasError="(errors.assignee_id || errors['action.assignee_id']) ? true : false" />
			        <div class="mt-1" style="width: 100%;">
				        <a href="javascript:void(0)" class="small" v-if="!showOtherUsers && (!value.other_assignees || value.other_assignees.length == 0)" v-on:click="showOtherUsers = true">
				            <i class="fa fa-plus"></i> Add Additional Assignees
				        </a>

				        <a href="javascript:void(0)" class="small pull-right" v-on:click="assignToMe()">
				            <i class="fa fa-user"></i> Assign to Me
				        </a>
			    	</div>
			        <div v-if="errors.assignee_id" class="text-danger">
			            <span v-for="error in errors.assignee_id">{{ error }}</span>
			        </div>
			        <div v-if="errors['action.assignee_id']" class="text-danger">
			            <span v-for="error in errors['action.assignee_id']">{{ error }}</span>
			        </div>
			    </div>
			</div>
		</div>

		<div class="form-group row" v-if="showOtherUsers || (value.other_assignees && value.other_assignees.length > 0)">
		    <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.other_assignees}">Other Assignees:</label>
		    <div class="col-sm-8">
		        <user-select ref="otherAssigneeSelect" @vuselected="otherAssigneeSelected" :resetOnOptionsChange="true" style="width: 100%" />
		        <div class="mt-1" v-if="value.other_assignees">
		            <div v-for="ass in value.other_assignees">
		                <a href="javascript:void(0)" class="text-danger mr-1" v-on:click="removeOtherAssignee(ass)" title="Remove Assignee"><i class="fa fa-remove"></i></a>
		                {{ ass.FirstName }} {{ ass.LastName }}
		            </div>
		        </div>
		    </div>
		    <hr/>
		</div>
	</div>
</template>

<script>
	export default {
		//V-model on the parent will automatically bind to "value"
		props: ["value", "errors", "enableTextMuted"],

		//Data
		data(){
			return {
				showOtherUsers: false,
			}
		},

		computed: {
		    userSelectValue() {
		    	//Check for null
		    	if(!this.value || !this.value.assignee_id)
		    	{
		    		return null;
		    	}

		    	//Return the data
		        return {
		            UserId: this.value.assignee_id,
		            FirstName: this.value.assignee_first_name,
		            LastName: this.value.assignee_last_name,
		            email: this.value.assignee_email
		        }
		    }
		},

		watch: {
            //Watcher for errors
            showOtherUsers(newValue, oldValue){
                //Set it
                this.hasError = newValue;
            },

            //Watcher for errors
            errors(newValue, oldValue){
                //Set it
                this.errors = newValue;
            },
        },

		methods: {
			onUserSelectUpdate ( user ) {
			    if (!user)
			    {
			        this.value.assignee_id = null;
			        this.value.assignee_first_name = null;
			        this.value.assignee_last_name = null;
			    }
			    else
			    {
			        this.value.assignee_id = user.UserId;
			        this.value.assignee_first_name = user.FirstName;
			        this.value.assignee_last_name = user.LastName;
			    }
			},

			assignToMe(){
				//Setup
				var me = {
		            UserId: this.$store.state.user.user_id,
		            FirstName: this.$store.state.user.first_name,
		            LastName: this.$store.state.user.last_name,
		            email: this.$store.state.user.email,
		        };

			    //Set the value
			    this.$refs.primaryAssigneeSelect.setValue(me);

			    //Set the value
			    this.onUserSelectUpdate(me);
			},

			otherAssigneeSelected(user){
			    //Check for nul
			    if(user == null)
			    {
			        return;
			    }

			    //Reset the selector
			    this.$refs.otherAssigneeSelect.reset();

			    //Create an object
			    var other_assignees = this.value.other_assignees ? this.value.other_assignees : [];

			    //Loop to make sure it doesn't exist
			    for(var i in other_assignees)
			    {
			        //Check it exists
			        if(other_assignees[i].UserId == user.UserId)
			        {
			            //Stop here
			            return;
			        }
			    }

			    //Push it
			    other_assignees.push(user);

			    //Push it
			    this.value.other_assignees = other_assignees;
			    this.$forceUpdate();
			},

			removeOtherAssignee(assignee){
			    //Create an object
			    var other_assignees = this.value.other_assignees ? this.value.other_assignees : [];

			    //Loop to make sure it doesn't exist
			    for(var i in other_assignees)
			    {
			        //Check it exists
			        if(other_assignees[i].UserId == assignee.UserId)
			        {
			            //remove it
			            other_assignees.splice(i, 1);

			            //Stop here
			            break;
			        }
			    }

			    //Push it
			    this.value.other_assignees = other_assignees;
			    this.$forceUpdate();
			}
		}
	}
</script>